import React, { useEffect, useState } from 'react';
import { baseUrl } from '../components/BaseUrl';
import axios from 'axios';
import moment from 'moment';
import '../App.css';
import { Link } from 'react-router-dom';
import { Button, Modal, Spinner } from 'react-bootstrap';
import Swal from "sweetalert2";
import { MyProSidebarProvider } from "../components/SidebarContext";
import LinearProgress from "@mui/material/LinearProgress";
import TopBar  from '../components/Topbar';
import Footer  from '../components/Footer';

const UserTrack = () => {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("codefussion-login-token");
  const [tracks, setTracks] = useState([]);
  const [task1, setTask1] = useState('');
  const [task2, setTask2] = useState('');
  const [task3, setTask3] = useState('');
  const [task4, setTask4] = useState('');
  const [enrolled, setEnrolled] = useState('');
  const [gitHubLink1, setGitHubLink1] = useState('');
  const [gitHubLink2, setGitHubLink2] = useState('');
  const [gitHubLink3, setGitHubLink3] = useState('');
  const [gitHubLink4, setGitHubLink4] = useState('');
  const [comment, setComment] = useState("");
  const [show, setShow] = useState(false);
  const [commenting, setCommenting] = useState(false);
  const [disabled, setDisabled] = useState(false)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const MAX_CHARS = 3600;
  const [charsLeft, setCharsLeft] = useState(0);
  let taskThree = null;
  let taskFour = null;

  const inputComment = (e) => {
      setComment(e.target.value);
      if(comment.length > MAX_CHARS ){
        setDisabled(true);
      }
  }

  const handleKeyPress = (e) => {

    if (comment.length >= MAX_CHARS) {
        e.preventDefault();
        e.stopPropagation();
    }
    }

  const fetchEnrollment = () => {
      setLoading(true);
      const userData = {
        email: localStorage.getItem("codefussion-student-email"),
      };
      axios.post(`${baseUrl}get-enrolled-student.php`, userData,
        { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      }).then((response) => {
        if(response.data.status === 0){
          setLoading(false);
          Swal.fire({
            title: "Error!",
            text: "An error occurred. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }else{
           response.data.map((item) => {
             taskThree = item.task_three
             taskFour = item.task_four
           })
           setTracks(response.data);
           setLoading(false);
        }
      });
    };

  const  showTracks = () => {
    if(tracks.length === 0){
      return(
        <div class="col-xl-12 col-sm-12 col-12 p-3">
        <p>You have no active tracks</p>
        </div>
      )
    }else{
    return tracks.map((item, index) => {
      return(
    <tbody>
      <p>{taskThree}</p>
      <tr>
        <td>{index+1}</td>
        <td>{item.track_enrolled}</td>
        <td>{item.courses.join(", ")}</td>
        <td>{item.task_one}</td>
        <td>{item.task_two}</td>
        <td>{item.task_three ? item.task_three: 'NILL'}</td>
        <td>{item.task_four ? item.task_four: 'NILL'}</td>
        <td>{item.duration}</td>
        <td className={item.completion_status === "in progress" ? "bg-warning" : item.completion_status === "completed" ? "bg-success" : "bg-danger" }>{item.completion_status}</td>
        <td>{moment(item.date_enrolled, "YYYYMMDD").fromNow()}</td>
        <td><button onClick={()=>handleShow(setEnrolled(item.track_enrolled), setTask1(item.task_one), setTask2(item.task_two), setTask3(item.task_three), setTask4(item.task_four))}>Submit</button></td>
      </tr>
      </tbody>
      )
    })
  }
  }

  const submitTask = () => {
    console.log(gitHubLink1)
      if(gitHubLink1 === ""){
        Swal.fire({
          title: "Empty Link",
          text: "At least one link required",
          icon: "error",
          confirmButtonText: "OK",
          backdrop: `
          rgba(143, 70, 0, 0.3)
          url("")
          left top
          no-repeat
        `
        });
      }
      else{
      const token = localStorage.getItem("codefussion-login-token");
      setCommenting(true);
      setDisabled(true);
      const userData = {
        first_name:  localStorage.getItem("codefussion-student-first-name") ,
        last_name: localStorage.getItem("codefussion-student-last-name"),
        email: localStorage.getItem("codefussion-student-email"),
        profile_photo: localStorage.getItem("codefussion-student-photo"),
        track: enrolled,
        task1: task1,
        task2: task2,
        task3: task3,
        task4: task4,
        link1: gitHubLink1,
        link2: gitHubLink2,
        link3: gitHubLink3,
        link4: gitHubLink4,
        message: comment,
      };
      axios.post(`${baseUrl}submit-task.php`, userData, { headers:
      { Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token
      }
    }).then((response) => {
      console.log(response.data)
        if(response.data.message === "Task submitted."){
          setCommenting(false);
          setDisabled(false);
          Swal.fire({
            title: "Success",
            text: "Task submitted successfully",
            icon: "success",
            confirmButtonText: "OK",
            backdrop: `
            rgba(143, 70, 0, 0.3)
            url("")
            left top
            no-repeat
          `
        }).then(()=> {
          setShow(false)
          window.location.replace("active-track")
        });

      }else if(response.data.message === "Already submitted"){
        Swal.fire({
          title: "Error",
          text: "You've already made a submission",
          icon: "error",
          confirmButtonText: "OK",
          backdrop: `
          rgba(143, 70, 0, 0.3)
          url("")
          left top
          no-repeat
        `
      })
      }else{
        Swal.fire({
          title: "Error",
          text: "Error updating recod. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
          backdrop: `
          rgba(143, 70, 0, 0.3)
          url("")
          left top
          no-repeat
        `
        });
        setCommenting(false);
        setDisabled(false);
      }
      });
    }
  }

    useEffect(() => {
      fetchEnrollment();
    },[])

  return(
   <MyProSidebarProvider>
    {localStorage.getItem("codefussion-login-token") === null ? window.location.replace("/login") :
    <div>
    <TopBar  />
      <div className="col-md-12">
      {loading ?  <div style={{ margin: 'auto', width: '50%', padding: '50px' }}>
          <div className="loader-wrapper" id="loading">
          <div className="loader">
          <div className="loader loader-inner"></div>
          </div>
          </div>
          </div> :
      <div>
     <h2 className="text-dark mt-4 font-weight-bold">Active Tracks</h2>
      <div className="col-md-12 col-lg-12 p-3" style={{ overflow: "auto" }}>
      <table class="table table-responsive table-condensed table-striped table-hover">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Track</th>
      <th scope="col">Courses</th>
      <th scope="col">First Task</th>
      <th scope="col">Second Task</th>
      <th scope="col">Third Task</th>
      <th scope="col">Fourth Task</th>
      <th scope="col">Duration</th>
      <th scope="col">Status</th>
      <th scope="col">Date</th>
      <th scope="col">Action</th>
    </tr>
     </thead>
      {showTracks()}
      </table>
      </div>
      </div>}
    </div>
    </div>
  }


  <Modal show={show} onHide={handleClose}>
   <Modal.Header className="bg-info" closeButton>
     <Modal.Title className="bg-info text-dark">Submit Task</Modal.Title>
   </Modal.Header>
   <Modal.Body>

<form>
<div class="mb-3">
  <h3>{enrolled}</h3>
  <label for="exampleInputEmail1" class="form-label">Task 1: {task1}</label>
  <input placeholder="GitHub link for task 1" type="text" class="form-control" onChange={(e) =>setGitHubLink1(e.target.value)} aria-describedby="emailHelp" />
</div>
<div class="mb-3">
  <label for="exampleInputEmail1" class="form-label">Task 2: {task2}</label>
  <input placeholder="GitHub link for task 2" type="text" class="form-control" onChange={(e) =>setGitHubLink2(e.target.value)} aria-describedby="emailHelp" />
</div>

{task3 !== "" ?
<div class="mb-3">
  <label for="exampleInputEmail1" class="form-label">Task 3: {task3}</label>
  <input placeholder="GitHub link for task 3" type="text" class="form-control" onChange={(e) =>setGitHubLink3(e.target.value)} aria-describedby="emailHelp" />
</div> : null }

{task4 !== "" ?
<div class="mb-3">
  <label for="exampleInputEmail1" class="form-label">Task 4: {task4}</label>
  <input placeholder="GitHub link for task 4" type="text" class="form-control" onChange={(e) =>setGitHubLink4(e.target.value)} aria-describedby="emailHelp" />
</div> : null}

 <div class="form-group mb-4">
 <label for="exampleInputEmail1" class="form-label">Notes / explanations (optional)</label>
 <textarea className="form-control status-box" onKeyPress={ handleKeyPress } onChange={inputComment} rows="3" placeholder="Enter your post here ..."></textarea>
  </div>
  <span>{MAX_CHARS - comment.length} characters left</span>
  <LinearProgress
   className="charProgress mb-4"
   variant="determinate"
   value={comment.length}
   />

 {comment.length >= MAX_CHARS ?
 <p  className="text-danger">Limit reached</p> : null }

 <button disabled={disabled} type="button" onClick={submitTask}>
 {commenting ? (
   <Spinner animation="border" variant="light" size="sm" />
 ) : (
   "Submit"
 )}
 </button>

</form>
</Modal.Body>
</Modal>

  </MyProSidebarProvider>
  )
}

export default UserTrack
